import React, { useState, useEffect, Suspense } from 'react'
import axios from 'axios'
import { Link, useNavigate } from 'react-router-dom'
import TagsInput from 'react-tagsinput'
import { useForm } from 'react-hook-form'
import { ReactSession } from 'react-client-session';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import styles from '../../../App.module.css'
import classes from './Share.module.css'
import Header from '../../Header/Header'
import Sidebar from '../../Sidebar/Sidebar'
import Tabs from '../Tabs/Tabs'
import Loader from '../../Global/Loader';

import noThumb from "../../../images/no-thumb.jpg";

function Share() {
  const navigate = useNavigate();
  const { register, handleSubmit, reset, formState: { errors } } = useForm();
  // const [embedUrl, setEmbedUrl] = React.useState([])
  // const [results, setResults] = useState([])
  const [video, setVideo] = useState([]);
  const [image, setImage] = useState(null);
  const [thumb, setThumb] = useState(null);
  const [vfile, setVfile] = useState(null);
  const [tags, setTags] = useState([]);
  const [ifDisabled, setIfDisabled] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState({
    status: false,
    type: '',
    message: ''
  });
  ReactSession.setStoreType("localStorage");

  const logged_user = ReactSession.get("logged_user");

  useEffect(() => {
    !logged_user && navigate('/login');
  } , [])

  // get data from api with body and post method
  const getData = (vfile) => {
    setVfile(vfile);

    axios.post(`${process.env.REACT_APP_API_URL}/api/embed.php`, {
        "vfile": vfile,
        "media": 1
      },
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(response => {
        console.log(response.data);
        if(response.data.status === 'success') {
          setVideo(response.data.data);
        }else {
          toast.error(response.data.message);
        }
      })
  }

  const handleChange = (tags) => {
    setTags(tags);

    reset({
        'tags': tags.toString()
    });
  }

  useEffect(() => {
      setImage(video.thumbnail);

      video.tags && video.tags.map && video.tags.map(tag => {
        setTags(tags => [...tags, tag])
      })

      reset({
        'title': video.title,
        'description': video.description,
        'tags': tags.toString(),
        'duration': video.duration || 0
      });
  }, [video])

  const onSubmit = data => {
    getData(data.vfile)
  }

  const onImageChange = (e) => {
    setThumb(e.target.files[0]);

    let reader = new FileReader();
    reader.onload = (e) => {
        setImage(e.target.result);
    };
    
    if(e.target.files[0]){
        reader.readAsDataURL(e.target.files[0]);
    }else {
        setImage(video.thumbnail);
    }
  }

  // console.log(video);

  const addVideo = (e) => {
    setIfDisabled(true);

    const data = new FormData();
    data.append('user_id', logged_user);
    data.append('file', vfile);
    data.append('media', 1)
    data.append('title', video.title);
    data.append('description', video.description);
    data.append('tags', tags.toString());
    data.append('duration', video.duration || 0);
    data.append('nsfw', e.nsfw);
    data.append('priv', e.priv);
    data.append('play-img', thumb);
    data.append('remote-img', video.thumbnail);

    // let formObject = Object.fromEntries(data.entries());
    // console.log(formObject);

    // const toast_id = toast.loading("Please wait...");
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/share.php`, data, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
      }).then(response => {
        console.log(response.data);
        setIsSubmitted({
          status: true,
          type: response.data.status,
          message: response.data.message
        });

        setIfDisabled(false);
      }).catch(err => {
          console.log(err);
      })
  }

  return (
    <>
      <Header />
      <ToastContainer />
      <div className={styles.main_body}>
        <Suspense fallback="<div>Please wait...</div>">
          <Sidebar />
        </Suspense>
        <Suspense fallback="<div>Please wait...</div>">
          <div className={styles.main_content + ` main-content`}>
            <div className="videos-component p-4">
              <Tabs active="share" />
              {
                video.length < 1 ? 
                  <div className={classes.panel}>
                    <div className={classes.panel_body}>
                      <div id="formVid" className="block mtop20 UploadForm">
                        <form onSubmit={handleSubmit(onSubmit)}>
                          <div className="form-group form-material floating">
                            <div className="form-control-wrap">
                                <label className={classes.floating_label}><i className="fa-solid fa-link"></i> &nbsp; Paste a link to a web video</label>
                            </div>
                            <div className="input-group">
                              <input {...register('vfile', {required: true})} type="url" id="vfile" name="vfile" className={classes.input_area + ` form-control`} placeholder="https://" />
                              <span className="input-group-btn">
                                <button className={classes.submit_btn + ` btn btn-primary`} type="submit">Embed</button>
                              </span>
                            </div>
                            <em className="mt-2 d-block text-muted">Paste use a valid url like https://youtu.be/glri7uEYYTo or https://vimeo.com/98062343</em>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="panel-footer">
                      <p className="text-center block mbot20 mtop20">
                        <strong>You can embed from:</strong>
                      </p>
                      <div className="row" id="supportedLinks">
                        <div className="col-md-2">Youtube</div>
                        <div className="col-md-2">Vimeo</div>
                        <div className="col-md-2">Gametrailers</div>
                        <div className="col-md-2">Metacafe</div>
                        <div className="col-md-2">Dailymotion</div>
                        <div className="col-md-2">Hell</div>
                        <div className="col-md-2">Trilulilu</div>
                        <div className="col-md-2">Viddler</div>
                        <div className="col-md-2">Blip</div>
                        <div className="col-md-2">Myspace</div>
                        <div className="col-md-2">Twitcam</div>
                        <div className="col-md-2">Ustream</div>
                        <div className="col-md-2">Liveleak</div>
                        <div className="col-md-2">Livestream</div>
                        <div className="col-md-2">Facebook</div>
                        <div className="col-md-2">Putlocker</div>
                        <div className="col-md-2">Vk</div>
                        <div className="col-md-2">Vine</div>
                        <div className="col-md-2">Telly</div>
                        <div className="col-md-2">Docs.google.com</div>{" "}
                      </div>
                    </div>
                  </div>
                :
                <div>
                  {
                    !isSubmitted.status ? <div className={classes.panel}>
                    <div className={classes.panel_body}>
                      <form onSubmit={handleSubmit(addVideo)}>
                        <div className="row">
                          <div className="col-8">
                            <div className="form-group">
                              <label>Title:</label>
                              <input {...register('title', {required: true})}  className="form-control" type="text" placeholder="Your Video's Title" />
                              {errors.title && <p className={styles.error_msg}>This field cannot be empty</p>}
                            </div>
                            <div className="form-group">
                              <label>Description:</label>
                              <textarea {...register('description')} className="form-control" rows="3" placeholder="Your Video's Description"></textarea>
                            </div>
                            <div className="form-group">
                              <label>Duration (in seconds):</label>
                              <input {...register('duration')}  className="form-control"  type="number" value="0" />
                            </div>
                            <div className="form-group">
                              <label>Channel:</label>
                              <select {...register('categ')} className="form-control">
                                  <optgroup label="Categories" dangerouslySetInnerHTML={{__html: `${video.cats}`}} />
                              </select>
                            </div>
                            <div className="form-group">
                              <label>Tags</label>
                              <TagsInput value={tags} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                              <div className="row">
                                <div className="col-6">
                                  <label>NSFW:</label>
                                  <div className={`form-group ${classes.radio}`}>
                                    <label className="radio d-inline-flex">
                                        <input {...register('nsfw')} type="radio" className="styled" value="1" /> <span>Not safe</span>
                                    </label>
                                    <label className="radio d-inline-flex">
                                        <input {...register('nsfw')} type="radio" className="styled" value="0" defaultChecked={true} /> <span>Safe</span>
                                    </label>
                                  </div>
                                </div>
                              <div className="col-6">
                                <div className="form-group">
                                  <label>Privacy:</label>
                                  <div className={`form-group ${classes.radio}`}>
                                      <label className="radio d-inline-flex">
                                          <input {...register('priv')} type="radio" className="styled" value="1" /> <span>Private</span>
                                      </label>
                                      <label className="radio d-inline-flex">
                                          <input {...register('priv')} type="radio" className="styled" value="0" defaultChecked={true} /> <span>Public</span>
                                      </label>
                                  </div>
                                </div>
                              </div>
                              </div>
                            </div>
                            <div className={`form-group mb-0 ${styles.btn_flex}`}>
                              <button className="btn btn-primary" type="submit" disabled={ifDisabled}>Save Video</button>
                              {
                                ifDisabled && <Loader />
                              }
                            </div>
                          </div>
                          <div className="col-4">
                            <div className={`${classes.video_thumb} mt-4 mb-3`}>
                              <label htmlFor="">Thumbnail:</label>
                              <img src={image} onError={e => {e.target.src = noThumb}} alt="thumb" />
                            </div>
                            <div className="form-group">
                                <label> Upload Thumbnails (350px X 250px):</label>
                                <input onChange={onImageChange}  className="form-control" type="file" />
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  : <div className='mt-4'>
                      <div className={`alert alert-${isSubmitted.type}`} role="alert">{isSubmitted.message}</div>
                        {
                          isSubmitted.type === 'success' && <div className="align-center" align="center">
                            <Link to="/dashboard/videos" className="btn btn-primary">Manage media.</Link>
                          </div>
                        }
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </Suspense>
      </div>
    </>
  )
}

export default Share